import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { MenuContext } from "../../providers/menu";

import LogoULagos from "../../assets/img/ulagos_bco-11.png";

// TODO: (Más adelante) crear módulo envío masivo de correos

const Sidebar = () => {
  const { toggled, sidebarItems } = useContext(MenuContext);
  return (
    <ul
      className={
        toggled
          ? "navbar-nav bg-gradient-primary sidebar sidebar-light accordion toggled"
          : "navbar-nav bg-gradient-primary sidebar sidebar-light accordion"
      }
      id="accordionSidebar"
    >
      {/* <!-- Sidebar - LOGO ULAGOS --> */}
      <a className="sidebar-brand d-flex align-items-center justify-content-center" href="/">
        <img
          src={LogoULagos}
          alt="logo-ulagos"
          className="img-responsive"
          style={{ width: "100%" }}
        />
      </a>

      <hr className="sidebar-divider my-0" />

      <hr className="sidebar-divider" />

      {sidebarItems.map((sidebarItem) => (
        <div>
          {/* Encabezado Categoría */}
          <div className="sidebar-heading">{sidebarItem.type}</div>

          {/* Items de primer nivel */}
          {sidebarItem.tree.map((firstLevelItem) =>
            // TODO: USAR TYPES DE LOS ITEM EN VEZ DE EVALUAR CHILD
            firstLevelItem.child ? (
              /* <!-- Nav Item - Pages Collapse Menu --> */
              <li className="nav-item">
                <a
                  href={`/${firstLevelItem.route}`}
                  className="nav-link collapsed"
                  data-toggle="collapse"
                  data-target={`#collapse${firstLevelItem.route}`}
                  aria-controls={`collapse${firstLevelItem.route}`}
                >
                  {firstLevelItem.icon ? (
                    <i className={firstLevelItem.icon}></i>
                  ) : (
                    <i className="fas fa-fw fa-eye"></i>
                  )}
                  <span>{firstLevelItem.name}</span>
                </a>

                <div
                  id={`collapse${firstLevelItem.route}`}
                  className="collapse"
                  aria-labelledby={`heading${firstLevelItem.route}`}
                  data-parent="#accordionSidebar"
                >
                  <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">Registro de {firstLevelItem.name}:</h6>

                    {[firstLevelItem.child].map((secondLevelItem) => (
                      <Link
                        className="collapse-item"
                        to={`/${firstLevelItem.route}/${secondLevelItem.route}`}
                      >
                        {secondLevelItem.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </li>
            ) : (
              /* <!-- Nav Link --> */
              <li className="nav-item">
                <Link className="nav-link" to={`/${firstLevelItem.route}`}>
                  {firstLevelItem.icon ? (
                    <i className={firstLevelItem.icon}></i>
                  ) : (
                    <i className="fas fa-fw fa-eye"></i>
                  )}
                  <span>{firstLevelItem.name}</span>
                </Link>
              </li>
            )
          )}
        </div>
      ))}
    </ul>
  );
};

export default Sidebar;
